const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  searchRoad ({ rootState }, params) {
    return rootState.axios.get('/zipcode/v1frontend/zipcode-tw/search-road', { params })
  },
  searchZip5 ({ rootState }, params) {
    return rootState.axios.get('/zipcode/v1frontend/zipcode-tw/search-zip5', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
